var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Game'),_c('p',{staticClass:"status"},[_vm._v("status: "+_vm._s(_vm.node))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }